// main.js
import { createApp } from 'vue'
import App from './App.vue'
import './assets/main.css'
import router from './router'
import Cookies from 'js-cookie'
import { DarkMode } from '@/legacy/initLegacy'   // keep your legacy init

// ——————————————————————————————
// 1) Session & AB‑variant
let sessionId = Cookies.get('sessionId')
if (!sessionId) {
  sessionId = crypto.randomUUID()
  Cookies.set('sessionId', sessionId, { expires: 1 })
}
const variant = Cookies.get('webDevVariant') || ''

// ——————————————————————————————
// 2) Scroll‑tracking state
let maxDepth   = 0
let hasSent    = false
let isFirstNav = true

// ——————————————————————————————
// 3) Track max scroll % on every scroll event
window.addEventListener('scroll', () => {
  const y     = window.pageYOffset || document.documentElement.scrollTop
  const total = document.documentElement.scrollHeight - window.innerHeight
  const pct   = total > 0 ? Math.floor((y / total) * 100) : 0
  if (pct > maxDepth) maxDepth = pct
})

// ——————————————————————————————
// 4) sendScroll() — fires exactly once per page
function sendScroll(path) {
  if (hasSent || maxDepth === 0) return
  hasSent = true

  const payload = JSON.stringify({
    sessionId,
    pageVariant: variant,
    scrollDepth: maxDepth,
    path
  })
  const blob = new Blob([payload], { type: 'application/json' })
  navigator.sendBeacon(
    'https://api.pairboard.com/neue/track-scroll',
    blob
  )
}

// ——————————————————————————————
// 5) Catch tab closes / hard reloads
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'hidden') {
    sendScroll(router.currentRoute.value.fullPath)
  }
})

// ——————————————————————————————
// 6) Boot the app & wire up SPA nav flush
const app = createApp(App)
app.use(router)

router.isReady().then(() => {
  // initialize your legacy code
  DarkMode.init()

  // afterEach fires on every route—including the first—so we skip the very first one
  router.afterEach((to, from) => {
    if (isFirstNav) {
      isFirstNav = false
    } else {
      sendScroll(from.fullPath)   // flush the page they just left
    }
    // reset for the next page
    maxDepth = 0
    hasSent  = false
  })

  app.mount('#app')
})
